$(document).ready(function () {
    // Click on link in video's that are disabled because social cookies are disabled
    $('a.allow-social-cookies, a.get-cookie-settings').click(function () {
        if ($('#cookie-popup-settings').length === 0) {
            AjaxCookiesFunction(true);
        }
    });

    // Check if the cookie popup has to be shown
    let blnShowCookies = GetLocalStorage('blnShowCookies');
    // Show the cookie popup or not, if not show the link in the footer
    if (!blnShowCookies) {
        AjaxCookiesFunction(false);
    } else {
        // Show the settings link
        $('footer').find('.get-cookie-settings').parent().removeClass('d-none');
        // Set the click event on the link
        setCookieSettings(blnShowCookies);
    }
});

// Ajax call for the cookies - only used for the social analytics, third party content
function AjaxCookiesFunction(blnShowPopup = false, allowCookiesSocial = false, blnTriggerPopup = true) {
    let strParams = 'blnShowCookies=' + blnShowPopup;
    strParams += '&allowCookiesSocial=' + allowCookiesSocial;
    $.ajax({
        type: 'GET',
        url: strAjaxPath + 'cookies.php',
        data: strParams,
        success: function (objResponse) {
            if (objResponse != '') {
                if (blnTriggerPopup) {
                    $('footer').after(objResponse);
                    inititalSettingsClick();
                    CheckAllCheckboxContent();
                }
                setCookieSettings();
            }
        },
        dataType: 'html',
        async: false,
    });
}

// Set chosen cookie settings
function setCookieSettings() {
    let blnShowCookies = GetLocalStorage('blnShowCookies');
    // click on a link with a data-cookie link
    $('[data-cookie]:not([data-cookie="init-settings"])').off('click').on('click', function (e) {
        let strChangeCookieBtn = $(this).attr('data-cookie');
        e.preventDefault(); // Voorkomt de standaardactie van het event.
        e.stopPropagation(); // Stopt bubbling naar hoger gelegen elementen.
        // allow all of decline all
        if (strChangeCookieBtn === 'allow-all') {
            SetLocalStorage('blnShowCookies', true);
            setAllCookies(true);
            AjaxCookiesFunction(true, true, false);
            closePopUp();
        } else if (strChangeCookieBtn === 'decline-all') {
            SetLocalStorage('blnShowCookies', true);
            setAllCookies(false);
            AjaxCookiesFunction(true, false, false);
            closePopUp();
        } else if (strChangeCookieBtn === 'settings') {
            AjaxCookiesFunction(blnShowCookies);
        }
    });
    // If you change one of the settings
    let objChangeSettings = $('#btnCookiebarConfirm');
    objChangeSettings.on('click', function (e) {
        SetLocalStorage('blnShowCookies', true);
        e.preventDefault(); // Voorkomt de standaardactie van het event.
        e.stopPropagation(); // Stopt bubbling naar hoger gelegen elementen.
        checkCookieContent($('#chkCookiesAnalytics'), 'allowCookiesAnalytics');
        checkCookieContent($('#chkCookiesSocial'), 'allowCookiesSocial');
        checkCookieContent($('#chkCookiesMarketing'), 'allowCookiesMarketing');
        closePopUp();
    });
}

// Extra function for the initial settings click in the first screen of the popup
function inititalSettingsClick() {
    $('[data-cookie="init-settings"]').on('click', function (e) {
        var objActiveItem = $(this).parents('.cookie-first.active');
        if (objActiveItem.length > 0) {
            objActiveItem.removeClass('active');
            objActiveItem.next().addClass('active');
        }
    });
}

// Close the popup = remove the html
function closePopUp() {
    $('#cookie-popup').remove();
    $('footer').find('[data-cookie="settings"]').parent().removeClass('d-none');
}

// Check if the checkboxes have to be checked yes or no
function CheckAllCheckboxContent() {
    checkCookie($('#chkCookiesAnalytics'), 'allowCookiesAnalytics');
    checkCookie($('#chkCookiesMarketing'), 'allowCookiesMarketing');
    checkCookie($('#chkCookiesSocial'), 'allowCookiesSocial');
}

// check the cookie checbox in the poup
function checkCookie(obj, strCookie) {
    if (GetLocalStorage(strCookie) == 'true') {
        obj.prop('checked', true);
    }
}

// check the content of the cookie
// triggered after a click
function checkCookieContent(obj, strCookie) {
    let blnCheck = false;
    if (obj.is(':checked')) {
        SetLocalStorage(strCookie, 'true');
        blnCheck = true;
    } else {
        if (typeof (Storage) !== 'undefined') {
            SetLocalStorage(strCookie, 'false');
        }
    }
    // If social cookies give to the ajax call
    let allowCookiesSocial;
    if (strCookie === 'allowCookiesSocial') {
        allowCookiesSocial = blnCheck;
        AjaxCookiesFunction(true, allowCookiesSocial, false);
    }
}

function setSocialCookies(bln) {
    SetLocalStorage('allowCookiesSocial', bln);
}

function SetAnalyticsCookies(bln) {
    SetLocalStorage('allowCookiesAnalytics', bln);
}

function SetMarketingCookies(bln) {
    SetLocalStorage('allowCookiesMarketing', bln);
}

function setAllCookies(bln) {
    SetLocalStorage('allowCookiesSocial', bln);
    SetLocalStorage('allowCookiesAnalytics', bln);
    SetLocalStorage('allowCookiesMarketing', bln);
}